import * as React from 'react';
import * as main from '../../../styles/main.module.scss';
import * as partners from './partners.module.scss';

export const Partners = () => {
  return (
    <section className={partners.partners}>
      <div className={"container"}>
        <div className={partners.partners__container}>
          <h2 className={main.mainTitle}>Нас поддерживают</h2>
          <ul className={partners.partners__list}>
            <li className={partners.partners__item}>
              <img
                src={"https://fs.advance.ru/landing-pages/webinar/krp_molodostmozga/partner-asi.png"}
                alt={""}
              />
            </li>
            <li className={partners.partners__item}>
              <img
                src={"https://fs.advance.ru/landing-pages/webinar/krp_molodostmozga/partner-sber.png"}
                alt={""}
              />
            </li>
            <li className={partners.partners__item}>
              <img
                src={"https://fs.advance.ru/landing-pages/webinar/krp_molodostmozga/partner-minprosvet.png"}
                alt={""}
              />
            </li>
            <li className={partners.partners__item}>
              <img
                src={"https://fs.advance.ru/landing-pages/webinar/krp_molodostmozga/partner-mgu.png"}
                alt={""}
              />
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
